import consentjson from '../consent.json';
import {
  getOr as lgetOr,
  compose as lcompose,
  startsWith as lstartsWith,
} from 'lodash/fp';

export const confirmDeclineConsent = { title: '', body: consentjson.download };

//RENEWAL uses the same consent as REVOKE
export const getConsents = ({
  reqType,
  role,
}: {
  reqType: 'ENROLL' | 'REVOKE';
  role: string;
}) => lcompose(lgetOr([], reqType === 'ENROLL' ? role : 'REVOKE'))(consents);

const consents = {
  REVOKE: [
    { title: consentjson.revokeConsentTitle, body: consentjson.revokeConsent },
  ],

  // registrant
  REG: [
    {
      title: consentjson.regLetterOnFileConsentTitle,
      body: consentjson.regLetterOnFileConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.consent },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.download },
  ],

  // coordinators
  POP: [
    { title: consentjson.consentTitle, body: consentjson.consent },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.download },
  ],
  APO: [
    { title: consentjson.consentTitle, body: consentjson.consent },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.download },
  ],

  // admin coordinators
  APC: [
    { title: consentjson.consentTitle, body: consentjson.consent },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.download },
  ],
  AAC: [
    { title: consentjson.consentTitle, body: consentjson.consent },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.consentTitle, body: consentjson.download },
  ],

  // power of attorney
  POA: [
    {
      title: consentjson.poaLetterOnFileConsentTitle,
      body: consentjson.poaLetterOnFileConsent,
    },
    { title: consentjson.poaConsentTitle, body: consentjson.poaConsent },
    {
      title: consentjson.privacyConsentTitle,
      body: consentjson.privacyConsent,
    },
    { title: consentjson.poaConsentTitle, body: consentjson.download },
  ],
};

export const getConsentDownloads = ({
  reqType,
  role,
}: {
  reqType: 'ENROLL' | 'REVOKE';
  role: string;
}) =>
  lcompose(lgetOr([], reqType === 'ENROLL' ? role : 'REVOKE'))(
    consentDownloads
  );

const consentDownloads = {
  REVOKE: [],
  REG: [
    'Registrant 1 of 3 CSOS Agreement.pdf',
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
  POP: [
    'Registrant 1 of 3 CSOS Agreement.pdf',
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
  APO: [
    'Registrant 1 of 3 CSOS Agreement.pdf',
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
  APC: [
    'Registrant 1 of 3 CSOS Agreement.pdf',
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
  AAC: [
    'Registrant 1 of 3 CSOS Agreement.pdf',
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
  POA: [
    'Registrant 2 of 3 CSOS Agreement.pdf',
    'Registrant 3 of 3 CSOS Agreement.pdf',
  ],
};

export const downloadConsent = lstartsWith('<p>You must download');
